// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__2Vwt_","input":"Input_input__Os-OC","error":"Input_error__2GZTY","readOnly":"Input_readOnly__3LrcA","adornment":"Input_adornment__1LcRy"};